import _ from 'lodash'

export function mergeFlags (flags1, flags2) {
  const resultFlags = Object.assign({}, flags1)
  if (flags2) {
    for (const key in flags2) {
      if (Object.hasOwnProperty.call(flags2, key)) {
        const element = flags2[key]
        if (!_.isNil(element)) {
          resultFlags[key] = element
        }
      }
    }
  }
  return resultFlags
}

export function matchFlags (source, flags, strict) {
  // debugger
  if (!source) return true
  for (const key in flags) {
    if (Object.hasOwnProperty.call(flags, key)) {
      const sourceFlag = source[key]
      const targetFlag = flags[key]
      if (strict) {
        if (Boolean(sourceFlag ?? false) ^ Boolean(targetFlag ?? false)) {
          return false
        }
      } else {
        if (!(_.isNil(sourceFlag) || _.isNil(targetFlag) || Boolean(sourceFlag) === Boolean(targetFlag))) {
          return false
        }
      }
    }
  }
  return true
}

export class RetryWorker {
  #action;
  #util;
  #interval;
  #state; // 0: ready; 1: started; 2: done; 3: cancelled
  // when started
  #promise;
  #promiseResolve;
  #promiseReject;

  #timerId;

  constructor (action, util, interval) {
    this.#action = action
    this.#util = util
    this.#interval = interval ?? 5000
    this.#state = 0
  }

  __setTimer (on) {
    if (on) {
      if (!this.#timerId) {
        this.#timerId = setTimeout(() => {
          this.#timerId = null
          this.__execute()
        }, this.#interval)
      }
    } else {
      if (this.#timerId) {
        clearTimeout(this.#timerId)
        this.#timerId = null
      }
    }
  }

  __checkUtil () {
    let success = false
    try {
      success = Boolean(this.#util())
    } catch (e) {
      console.error('重试任务检查条件时出错', e)
    }
    if (success) {
      this.#state = 2
      this.__setTimer(false)
      this.#promiseResolve(true)
      this.#promise = null
      this.#promiseResolve = null
      this.#promiseReject = null
    }
    return success
  }

  __execute () {
    if (this.#state !== 1) {
      return
    }
    if (this.__checkUtil()) {
      return
    }
    try {
      const actionResult = this.#action()
      if (actionResult instanceof Promise) {
        actionResult.catch(actionError => {
          console.error('执行重试任务时出错', actionError)
        }).finally(() => {
          if (this.#state !== 1) {
            return
          }
          if (!this.__checkUtil()) {
            this.__setTimer(true)
          }
        })
      } else {
        if (!this.__checkUtil()) {
          this.__setTimer(true)
        }
      }
    } catch (e) {
      console.error('执行重试任务时出错', e)
    }
  }

  start () {
    switch (this.#state) {
      case 0: // ready
        if (!this.#promise) {
          this.#promise = new Promise((resolve, reject) => {
            this.#promiseResolve = resolve
            this.#promiseReject = reject
          })
        }
        this.#state = 1
        this.__execute()
        return this.#promise
      case 1: // started
      case 2: // done
      case 3: // cancelled
      default:
        throw new Error('RetryWorker start on state:' + this.#state)
    }
  }

  stop () {
    switch (this.#state) {
      case 0:
        return true
      case 1:
        this.__setTimer(false)
        this.#state = 0
        return true
      case 2:
      case 3:
      default:
        return false
    }
  }

  cancel () {
    switch (this.#state) {
      case 0:
      case 1:
        this.__setTimer(false)
        this.#promiseResolve(false)
        this.#promise = null
        this.#promiseResolve = null
        this.#promiseReject = null
        this.#state = 3
        break
      case 2:
      case 3:
      default:
        break
    }
  }
}
